import { motion } from 'framer-motion';
import { botanical, images } from '../data/site';

export default function Hero() {
  return (
    <section className="hero section" id="home">
      <div className="container hero-grid">
        <motion.div className="hero-copy" initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.55 }}>
          <span className="eyebrow pill">A PLACE TO GROW, LEARN &amp; SHINE</span>
          <h1>Every Little Step<br />Builds a <span className="green">Brighter Future.</span></h1>
          <p>At Minrose Child Development Center, we believe every child has a unique way of discovering the world. We're here to nurture their potential, encourage their curiosity, and support their journey of growth.</p>
          <div className="button-row">
            <a className="button button-dark" href="#about">Discover Our Center <span aria-hidden="true">→</span></a>
            <a className="button button-outline" href="#contact">Get in Touch</a>
          </div>
          <p className="hero-note"><span aria-hidden="true">❧</span> Every child is unique. Every little milestone matters.</p>
        </motion.div>
        <motion.div className="hero-visual" initial={{ opacity: 0, scale: 0.97 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.65 }}>
          <img className="hero-photo" src={images.hero} alt="Children exploring colorful learning materials together" fetchPriority="high" width="900" height="650" />
          <div className="hero-sticker">Little moments.<br />Lifelong possibilities. <span aria-hidden="true">♡</span></div>
          <img className="botanical hero-botanical" src={botanical} alt="" aria-hidden="true" />
        </motion.div>
      </div>
    </section>
  );
}